import { Navigate, Outlet, Route, Routes } from 'react-router-dom'
import { ProfileHeader } from './profile-header'
import { PageTitle } from '_metronic/layout/core'
import { t } from 'i18next'
import ConnectApp from './connect-app/connect-app'
import ConnectedApps from './connected-apps/connected-apps'
import PermissionWrapper from '@/core/wrappers/permission-wrapper'
import { PERMISSION_CONSTANTS } from '@/core/constants/common/permission-constants'
import NewCredential from './new-credential/new-credential'
import ProfileInformations from './profile-informations/profile-informations'

const profileBreadCrumbs: Array<any> = [
  {
    title: 'Profile',
    path: '/profile/profile-informations',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const ProfilePage = () => (
  <Routes>
    <Route
      element={
        <>
          <ProfileHeader />
          <Outlet />
        </>
      }
    >
      <Route
        path='profile-informations'
        element={
          <>
            <PageTitle breadcrumbs={profileBreadCrumbs}>{t('profile_informations')}</PageTitle>
            <ProfileInformations />
          </>
        }
      />
      <Route
        path='new-credential'
        element={
          <>
            <PageTitle breadcrumbs={profileBreadCrumbs}>{t('new_credential')}</PageTitle>
            <NewCredential />
          </>
        }
      />
      <Route
        path='connect-app'
        element={
          <PermissionWrapper permission={PERMISSION_CONSTANTS.CONNECTED_APP} action="Create">
            <PageTitle breadcrumbs={profileBreadCrumbs}>{t('connect_app')}</PageTitle>
            <ConnectApp />
          </PermissionWrapper>
        }
      />
      <Route
        path='connected-apps'
        element={
          <PermissionWrapper permission={PERMISSION_CONSTANTS.CONNECTED_APP} action="Create">
            <PageTitle breadcrumbs={profileBreadCrumbs}>{t('connected_apps')}</PageTitle>
            <ConnectedApps />
          </PermissionWrapper>
        }
      />
      <Route index element={<Navigate to='/profile/profile-informations' />} />
    </Route>
  </Routes>
)

export default ProfilePage
